export default __webpack_public_path__ + "static/media/sad_male.230a6e33.png";